import { ElementType } from 'react';
import { IconCalendarOutline, IconPercent, IconPound } from '@iwoca/icons';
import { Radio, Pill } from '@iwoca/orion';
import { PillProps } from '@iwoca/orion/lib/components/pill/Pill';
import clsx from 'clsx';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { BREAK_S } from 'utils/breakpoints';
import styles from './OfferTab.module.css';

type TProps = {
  icon: ElementType;
  mobileIcon: ElementType;
  duration: string;
  amount: string;
  interest: string;
  pill: { variant: NonNullable<PillProps['variant']>; label: string } | null;
  isSelected: boolean;
  isSelectable: boolean;
  onSelect: () => void;
};

export const OfferTab = ({
  isSelected,
  isSelectable,
  onSelect,
  icon: IconComponent,
  mobileIcon: MobileIconComponent,
  duration,
  amount,
  interest,
  pill,
}: TProps) => {
  const { width } = useWindowDimensions();
  const isMobile = width <= BREAK_S;

  const details = [
    { id: 'duration', icon: IconCalendarOutline, value: duration },
    { id: 'amount', icon: IconPound, value: amount },
    {
      id: 'interest',
      icon: IconPercent,
      value: (
        <>
          {interest} <span className={styles.interest}>* 30 day interest</span>
        </>
      ),
    },
  ] as const;

  const showDetails = !isMobile || isSelected;

  return (
    <button
      onClick={onSelect}
      className={clsx(styles.container, {
        [styles.isSelected]: isSelected,
        [styles.isSelectable]: isSelectable,
      })}
    >
      {isSelectable && <Radio checked={isSelected} onChange={onSelect} />}
      <div className={styles.content}>
        <div className={styles.offerIcon}>
          {isMobile ? <MobileIconComponent /> : <IconComponent />}
        </div>
        <div className={styles.details}>
          {pill && (
            <Pill
              variant={pill.variant}
              className={clsx(styles.tintedPill, styles[pill.variant])}
            >
              {pill.label}
            </Pill>
          )}
          {showDetails &&
            details.map(({ id, icon: Icon, value }) => (
              <div className={styles.detail} key={id}>
                <Icon fontSize="20px" className={styles.detailIcon} />
                <p className={styles.value}>{value}</p>
              </div>
            ))}
        </div>
      </div>
    </button>
  );
};
